import map from 'lodash/map';
import { customTheme } from 'theme';

import { WithResourceIcon } from 'components/DataDisplay';
import { IconTypes } from 'components/Icons';
import { toTitleCase } from 'utils/string';
import { PatchRecommendationPackageSource } from 'services/Vulnerability/types';

export const fixPlanSourceOptions = [
  {
    label: 'All',
    value: undefined,
  },
  ...map(PatchRecommendationPackageSource, o => ({
    label: o,
    value: o,
  })),
];

export const renderResourceState = row => {
  return !!row?.state ? (
    <WithResourceIcon
      resourceType={
        row?.state === 'running' ? IconTypes.SyncRestart : IconTypes.SyncPause
      }
      iconFilled={false}
      iconSize="xs"
      color={customTheme.colors.gray['300']}
      spacing={1}
    >
      {toTitleCase(row?.state ?? '')}
    </WithResourceIcon>
  ) : (
    '-'
  );
};
